// @ts-expect-error untyped module
import CountrySelect from 'ui-addon-i18n/components/CountrySelect';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useMemo } from 'react';
import { useFilterChangeHandler } from '../../hooks/useFilterChangeHandler';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CountryFilter({
  filter,
  excludedCountries
}) {
  const params = useSearchParams();
  const handleChange = useFilterChangeHandler({
    filter,
    isMulti: true
  });
  const optionsFilter = useMemo(() => {
    if (!(excludedCountries !== null && excludedCountries !== void 0 && excludedCountries.length)) return undefined;
    return option => !excludedCountries.includes(option.value.toLowerCase());
  }, [excludedCountries]);
  if (!filter) return null;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(FormLabel, {
      htmlFor: `eco_${filter.field}`,
      children: filter.label
    }), /*#__PURE__*/_jsx(CountrySelect, {
      id: `eco_${filter.field}`,
      multi: true,
      onChange: e => handleChange({
        target: {
          value: e.target.value.map(code => code.toUpperCase())
        }
      }),
      optionsFilter: optionsFilter,
      placeholder: filter.placeholder,
      value: params.getList(filter.field).map(code => code.toLowerCase())
    })]
  });
}